// DOM
const elements = document.querySelectorAll('.js-jg-in-viewport');
const inViewportClass = 'jg-in-viewport';

// Config
const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    // Trigger when the element is 100% visible
    threshold: 1.0
};

const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add(inViewportClass);
            // Stop observing element
            observer.unobserve(entry.target);
        }
    });
};

const observeElements = () => {
    const observer = new IntersectionObserver(handleIntersection, observerOptions);
    elements.forEach(element => observer.observe(element));
};

function init() {
    observeElements();
}

export default {
    init
};
